
import { useEffect, useState, useRef, useMemo } from "react";
import { jwtDecode } from "jwt-decode";
// import { FiSend, FiPaperclip, FiArrowLeft } from "react-icons/fi";
import { FiSend, FiPaperclip, FiArrowLeft, FiDownload } from "react-icons/fi";
import socket from "../../utils/socket";

import React from "react";

const RFQChatBox = ({ groupId, chatTitle, receivers = [], onClose, visible }) => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [typingUser, setTypingUser] = useState("");
    const [mentionList, setMentionList] = useState([]);
    const [mentionDropdown, setMentionDropdown] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [attachment, setAttachment] = useState(null); // { name, data, type }


    const [isReceiverOnline, setIsReceiverOnline] = useState(false);

    const [showUserList, setShowUserList] = useState(true);
    const [selectedChat, setSelectedChat] = useState({
        groupId: null,
        receiverId: null,
        receiverName: "",
        chatTitle: "",
        avatar: null,
    });

    // // --- NEW: Notification states ---
    // const [toast, setToast] = useState({ visible: false, message: '', sender: '' });
    // const [isWindowFocused, setIsWindowFocused] = useState(true);

    const messagesEndRef = useRef(null);
    const fileInputRef = useRef(null);
    const token = localStorage.getItem("token");
    const storedUser = jwtDecode(token);

    const currentUser = useMemo(() => ({
        userId: storedUser?.userId,
        type: storedUser?.roles,
        name: storedUser?.userName,
        buyerId: storedUser?.buyerId,
    }), [storedUser?.userId, storedUser?.roles, storedUser?.userName, storedUser?.buyerId]);

    const REACT_APP_API_BASE_URL =
        process.env.REACT_APP_API_BASE_URL || "http://localhost:9001";

    const users = useMemo(() => receivers || [], [receivers]);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        let h = date.getHours();
        const m = date.getMinutes().toString().padStart(2, "0");
        const ampm = h >= 12 ? "PM" : "AM";
        h = h % 12 || 12;
        return `${h}:${m} ${ampm}`;
    };

    const getColor = (name) => {
        const colors = ["#4F46E5", "#059669", "#DC2626", "#D97706", "#0891B2"];
        return colors[name?.length % colors.length] || "#4F46E5";
    };

    const highlightIfMentioned = (msg) => msg.includes(`@${currentUser.name}`);

    // // --- NEW: Notification & sound functions ---
    // const playNotificationSound = () => {
    //     try {
    //         const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    //         const oscillator = audioCtx.createOscillator();
    //         const gainNode = audioCtx.createGain();
    //         oscillator.connect(gainNode);
    //         gainNode.connect(audioCtx.destination);
    //         oscillator.frequency.value = 800;
    //         oscillator.type = 'sine';
    //         gainNode.gain.setValueAtTime(0.3, audioCtx.currentTime);
    //         gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.2);
    //         oscillator.start(audioCtx.currentTime);
    //         oscillator.stop(audioCtx.currentTime + 0.2);
    //     } catch (e) {
    //         // Silently fail
    //     }
    // };

    // const showNotification = (senderName, message) => {
    //     // Browser notification
    //     if ("Notification" in window && Notification.permission === "granted") {
    //         new Notification(`💬 New message from ${senderName}`, {
    //             body: message,
    //             icon: "/path/to/your/icon.png" // replace with your own icon URL
    //         });
    //     }
    //     // In-app toast
    //     setToast({ visible: true, message, sender: senderName });
    //     setTimeout(() => setToast({ visible: false, message: '', sender: '' }), 5000);
    //     // Play sound
    //     playNotificationSound();
    // };

    const selectUser = (user) => {
        const ids = [currentUser.userId, user.AssociateNumber].sort();
        const privateGroupId = `${groupId}_${ids.join('_')}`;
        setSelectedChat({
            groupId: privateGroupId,
            receiverId: user.AssociateNumber,
            receiverName: user.organisationName,
            chatTitle: user.organisationName,
            avatar: user.avatar,
        });
        setShowUserList(false);
        setMessages([]);
    };

    const previousGroupIdRef = useRef(null);

    // // --- NEW: Window focus effect ---
    // useEffect(() => {
    //     const handleFocus = () => setIsWindowFocused(true);
    //     const handleBlur = () => setIsWindowFocused(false);
    //     window.addEventListener('focus', handleFocus);
    //     window.addEventListener('blur', handleBlur);
    //     return () => {
    //         window.removeEventListener('focus', handleFocus);
    //         window.removeEventListener('blur', handleBlur);
    //     };
    // }, []);

    // // --- NEW: Request notification permission ---
    // useEffect(() => {
    //     if ("Notification" in window && Notification.permission === "default") {
    //         Notification.requestPermission();
    //     }
    // }, []);

    useEffect(() => {
        if (showUserList || !selectedChat.groupId) {
            if (previousGroupIdRef.current) {
                socket.emit("leaveRoom", previousGroupIdRef.current);
                previousGroupIdRef.current = null;
            }
            return;
        }

        const groupId = selectedChat.groupId;
        if (previousGroupIdRef.current === groupId) return;
        previousGroupIdRef.current = groupId;

        if (!socket.connected) socket.connect();
        socket.emit("joinRoom", { groupId });

        const fetchMessages = async () => {
            try {
                const response = await fetch(
                    `${REACT_APP_API_BASE_URL}socket/api/getMessagesByGroupId`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({ groupId }),
                    }
                );
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                const msgs = Array.isArray(data) ? data : data?.messages || [];
                setMessages(msgs);
                scrollToBottom();

                const unreadIds = msgs
                    .filter(msg => msg.senderId !== currentUser.userId && !msg.isReadBy?.includes(currentUser.userId))
                    .map(msg => msg._id);
                if (unreadIds.length > 0) {
                    socket.emit("markRead", {
                        groupId: selectedChat.groupId,
                        readerId: currentUser.userId,
                    });
                    setMessages(prev =>
                        prev.map(msg => {
                            if (unreadIds.includes(msg._id)) {
                                return { ...msg, isReadBy: [...(msg.isReadBy || []), currentUser.userId] };
                            }
                            return msg;
                        })
                    );
                }
            } catch (error) {
                console.error("Fetch error:", error.message);
            }
        };

        fetchMessages();

        const fetchMentionUser = async () => {
            try {
                const response = await fetch(
                    `${REACT_APP_API_BASE_URL}socket/api/fetchMentionUser`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({ senderId: currentUser.userId }),
                    }
                );
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setMentionList(data);
            } catch (error) {
                console.error("Mention user fetch error:", error.message);
            }
        };
        fetchMentionUser();

        // --- UPDATED: handleNewMessage with notification ---
        const handleNewMessage = (msg) => {
            if (msg.senderId === currentUser.userId) return;
            if (msg.groupId === groupId) {
                setMessages((prev) => [...prev, msg]);
                scrollToBottom();

                // Show notification only if chat is not visible or tab not focused
                // if (!visible || !isWindowFocused) {
                //     showNotification(msg.senderName, msg.message);
                // }
            }
        };

        const handleTyping = ({ userName, chatId }) => {
            if (groupId === chatId && userName !== currentUser.name) {
                setTypingUser(userName);
                setIsTyping(true);
                setTimeout(() => setIsTyping(false), 3000);
            }
        };

        socket.on("newMessage", handleNewMessage);
        socket.on("typing", handleTyping);

        socket.on("userOnline", ({ userId, groupId }) => {
            if (groupId === selectedChat.groupId && userId === selectedChat.receiverId) {
                setIsReceiverOnline(true);
            }
        });

        socket.on("userOffline", ({ userId }) => {
            if (userId === selectedChat.receiverId) {
                setIsReceiverOnline(false);
            }
        });

        socket.on("messageRead", ({ groupId, readerId }) => {
            if (groupId === selectedChat.groupId) {
                setMessages(prevMessages =>
                    prevMessages.map(msg => {
                        if (msg.senderId === currentUser.userId && msg.receiverIds?.includes(selectedChat.receiverId)) {
                            if (!msg.isReadBy?.includes(readerId)) {
                                return { ...msg, isReadBy: [...(msg.isReadBy || []), readerId] };
                            }
                        }
                        return msg;
                    })
                );
            }
        });

        return () => {
            socket.emit("leaveRoom", groupId);
            socket.off("newMessage", handleNewMessage);
            socket.off("typing", handleTyping);
            if (previousGroupIdRef.current === groupId) {
                previousGroupIdRef.current = null;
            }
        };
    }, [selectedChat.groupId, selectedChat.receiverId, showUserList, REACT_APP_API_BASE_URL, token, currentUser.userId, currentUser.name]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInput(value);
        socket.emit("typing", { userName: currentUser.name, groupId: selectedChat.groupId });

        const mentionMatch = value.match(/@(\w*)$/);
        if (mentionMatch) {
            const query = mentionMatch[1]?.toLowerCase();
            const filtered = mentionList.filter((u) =>
                u.name.toLowerCase().startsWith(query)
            );
            setMentionDropdown(filtered);
            setShowDropdown(true);
        } else {
            setShowDropdown(false);
        }
    };

    const handleMentionSelect = (name) => {
        const newText = input.replace(/@(\w*)$/, `@${name} `);
        setInput(newText);
        setShowDropdown(false);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (ev) => {
            setAttachment({
                name: file.name,
                data: ev.target.result,
                type: file.type,
            });
        };
        reader.readAsDataURL(file);
        e.target.value = '';
    };

    const handleSend = () => {
        if (!input.trim() && !attachment) return;

        const newMsg = {
            groupId: selectedChat.groupId,
            rfqId: groupId, // <-- ADD THIS LINE (the original RFQ ID passed as prop)
            chatId: selectedChat.groupId,
            senderId: currentUser.userId,
            senderType: currentUser.type,
            senderName: currentUser.name,
            receiverIDs: [selectedChat.receiverId],
            rfqNo: chatTitle,
            message: input,
            attachment: attachment ? {
                name: attachment.name,
                data: attachment.data,
                type: attachment.type,
            } : null,
            timestamp: new Date().toISOString(),
        };

        console.log("📤 Sending message with rfqId:", newMsg.rfqId); // ADD THIS
        socket.emit("sendMessage", newMsg);
        setMessages((prev) => [...prev, { ...newMsg, senderName: currentUser.name }]);
        setInput("");
        setAttachment(null);
        scrollToBottom();
    };

    useEffect(() => {
        if (!socket.connected) socket.connect();
        socket.emit("setUser", { userId: currentUser.userId });
    }, [currentUser.userId]);

    // Convert a data URL (base64) to a Blob object
    const dataUrlToBlob = (dataUrl) => {
        const [header, data] = dataUrl.split(',');
        const mime = header.match(/:(.*?);/)[1];
        const binary = atob(data);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            array[i] = binary.charCodeAt(i);
        }
        return new Blob([array], { type: mime });
    };

    // Open a file in a new tab using a Blob URL
    const handleViewAttachment = (dataUrl) => {
        const blob = dataUrlToBlob(dataUrl);
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        // The blob URL stays valid until the document is closed.
        // You can optionally revoke it after a delay (e.g., 10s) if you prefer.
        // setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    };

    const formatMessage = (text) => {
        // Escape HTML entities
        let html = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        // Bold: **text** -> <strong>text</strong>
        html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        // Newlines to <br>
        html = html.replace(/\n/g, '<br />');
        // Mentions: @word -> span with style
        html = html.replace(/@(\w+)/g, '<span style="color:#0b93f6;font-weight:bold;">@$1</span>');
        return html;
    };

    return (
        <>
            {/* Toast Notification */}


            {/* Main Chat Window */}
            <div
                style={{
                    ...styles.wrapper,
                    transform: visible ? "translateX(0%)" : "translateX(100%)",
                }}
            >
                <div style={styles.header}>
                    <span style={styles.headerTitle}>
                        📋 Chats {chatTitle}
                    </span>
                    <button onClick={onClose} style={styles.closeBtn}>×</button>
                </div>

                {showUserList ? (
                    <div style={{ ...styles.body, padding: 0 }}>
                        {users.map((user) => (
                            <div
                                key={user.AssociateNumber}
                                style={styles.userItem}
                                onClick={() => selectUser(user)}
                            >
                                {user.avatar ? (
                                    <img src={user.avatar} alt="avatar" style={styles.avatar} />
                                ) : (
                                    <div
                                        style={{
                                            ...styles.avatarPlaceholder,
                                            backgroundColor: getColor(user.organisationName),
                                        }}
                                    >
                                        {user.organisationName?.charAt(0).toUpperCase()}
                                    </div>
                                )}
                                <div style={styles.userInfo}>
                                    <div style={styles.userName}>{user.organisationName}</div>
                                    <div style={styles.lastMessage}>
                                        {user.contactfirstName || "Tap to chat"}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        <div style={styles.chatHeader}>
                            <button style={styles.backBtn} onClick={() => setShowUserList(true)}>
                                <FiArrowLeft size={20} />
                            </button>
                            <div style={styles.chatAvatarWrapper}>
                                {selectedChat.avatar ? (
                                    <img src={selectedChat.avatar} alt="" style={styles.avatar} />
                                ) : (
                                    <div
                                        style={{
                                            ...styles.avatarPlaceholder,
                                            backgroundColor: getColor(selectedChat.receiverName),
                                        }}
                                    >
                                        {selectedChat.receiverName?.charAt(0).toUpperCase()}
                                    </div>
                                )}
                            </div>
                            <div style={styles.chatUserInfo}>
                                <div style={styles.chatUserName}>{selectedChat.receiverName}</div>
                                <div style={styles.chatUserStatus}>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: 8,
                                            height: 8,
                                            borderRadius: "50%",
                                            backgroundColor: isReceiverOnline ? "#4CAF50" : "#b0b0b0",
                                            marginRight: 6,
                                        }}
                                    />
                                    {isReceiverOnline ? "Online" : "Offline"}
                                </div>
                            </div>
                        </div>

                        <div style={styles.body}>
                            {messages.map((msg, i) => {
                                const isSender = msg.senderId === currentUser.userId;
                                const highlight = highlightIfMentioned(msg.message);
                                return (
                                    <div
                                        key={i}
                                        style={{
                                            ...styles.messageRow,
                                            justifyContent: isSender ? "flex-end" : "flex-start",
                                        }}
                                    >
                                        <div
                                            style={{
                                                ...styles.messageBubble,
                                                backgroundColor: highlight
                                                    ? "#fff8b3"
                                                    : isSender
                                                        ? "#d9fdd3"
                                                        : "#f0f0f0",
                                            }}
                                        >
                                            <div style={styles.sender}>
                                                {isSender ? "You" : msg.senderName}
                                            </div>
                                            {/* <div
                                                dangerouslySetInnerHTML={{
                                                    __html: msg.message.replace(
                                                        /@(\w+)/g,
                                                        '<span style="color:#0b93f6;font-weight:bold;">@$1</span>'
                                                    ),
                                                }}
                                            /> */}

                                            <div
                                                dangerouslySetInnerHTML={{ __html: formatMessage(msg.message) }}
                                            />

                                            {/* {msg.attachment && (
                                                <div style={{ marginTop: 8 }}>
                                                    {msg.attachment.type?.startsWith('image/') ? (
                                                        <img
                                                            src={msg.attachment.data}
                                                            alt={msg.attachment.name}
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: 150,
                                                                borderRadius: 8,
                                                                border: '1px solid #ddd',
                                                            }}
                                                        />
                                                    ) : (
                                                        <a
                                                            href={msg.attachment.data}
                                                            download={msg.attachment.name}
                                                            style={{
                                                                color: '#0077cc',
                                                                textDecoration: 'underline',
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            📎 {msg.attachment.name}
                                                        </a>
                                                    )}
                                                </div>
                                            )} */}

                                            {/* {msg.attachment && (
                                                <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                    {msg.attachment.type?.startsWith('image/') ? (
                                                        <div>
                                                            <img
                                                                src={msg.attachment.data}
                                                                alt={msg.attachment.name}
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    maxHeight: 150,
                                                                    borderRadius: 8,
                                                                    border: '1px solid #ddd',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => window.open(msg.attachment.data, '_blank')}
                                                            />
                                                            <div style={{ marginTop: 4, display: 'flex', gap: 8, alignItems: 'center' }}>
                                                                <span style={{ fontSize: 12, color: '#555' }}>{msg.attachment.name}</span>
                                                                <a
                                                                    href={msg.attachment.data}
                                                                    download={msg.attachment.name}
                                                                    style={{ color: '#0077cc', fontSize: 14 }}
                                                                    title="Download"
                                                                >
                                                                    <FiDownload size={16} />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <a
                                                                href={msg.attachment.data}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: '#0077cc', textDecoration: 'underline', fontWeight: 500 }}
                                                            >
                                                                📎 {msg.attachment.name}
                                                            </a>
                                                            <a
                                                                href={msg.attachment.data}
                                                                download={msg.attachment.name}
                                                                style={{ color: '#0077cc', fontSize: 14 }}
                                                                title="Download"
                                                            >
                                                                <FiDownload size={16} />
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            )} */}

                                            {msg.attachment && (
                                                <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                    {msg.attachment.type?.startsWith('image/') ? (
                                                        <div>
                                                            <img
                                                                src={msg.attachment.data}
                                                                alt={msg.attachment.name}
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    maxHeight: 150,
                                                                    borderRadius: 8,
                                                                    border: '1px solid #ddd',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => handleViewAttachment(msg.attachment.data)}
                                                            />
                                                            <div style={{ marginTop: 4, display: 'flex', gap: 8, alignItems: 'center' }}>
                                                                <span style={{ fontSize: 12, color: '#555' }}>{msg.attachment.name}</span>
                                                                <a
                                                                    href={msg.attachment.data}
                                                                    download={msg.attachment.name}
                                                                    style={{ color: '#0077cc', fontSize: 14 }}
                                                                    title="Download"
                                                                >
                                                                    <FiDownload size={16} />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <span
                                                                onClick={() => handleViewAttachment(msg.attachment.data)}
                                                                style={{
                                                                    color: '#0077cc',
                                                                    textDecoration: 'underline',
                                                                    fontWeight: 500,
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                📎 {msg.attachment.name}
                                                            </span>
                                                            <a
                                                                href={msg.attachment.data}
                                                                download={msg.attachment.name}
                                                                style={{ color: '#0077cc', fontSize: 14 }}
                                                                title="Download"
                                                            >
                                                                <FiDownload size={16} />
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            <div style={styles.timestamp}>
                                                {formatTime(msg.timestamp)}
                                                {isSender && (
                                                    <span
                                                        style={{
                                                            marginLeft: 6,
                                                            color: msg.isReadBy?.includes(selectedChat.receiverId)
                                                                ? "#34B7F1"
                                                                : "#999"
                                                        }}
                                                    >
                                                        {msg.isReadBy?.includes(selectedChat.receiverId) ? '✓✓' : '✓'}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {isTyping && (
                                <div style={styles.typingContainer}>
                                    <div style={styles.typingDot} />
                                    <div style={styles.typingDot} />
                                    <div style={styles.typingDot} />
                                    <span style={{ marginLeft: 8, color: "#888", fontSize: 13 }}>
                                        {typingUser} is typing...
                                    </span>
                                </div>
                            )}

                            <div ref={messagesEndRef} />
                        </div>

                        <div style={styles.inputArea}>
                            <div style={styles.inputWrapper}>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />



                                <button
                                    style={styles.attachBtn}
                                    onClick={() => fileInputRef.current?.click()}
                                    title="Attach file"
                                >
                                    <FiPaperclip size={18} color="#555" />
                                </button>

                                {/* <input
                                    type="text"
                                    placeholder="Type your message..."
                                    value={input}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => e.key === "Enter" && handleSend()}
                                    style={styles.input}
                                /> */}
                                <textarea
                                    placeholder="Type your message..."
                                    value={input}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            handleSend();
                                        }
                                        // Shift+Enter will naturally add a newline
                                    }}
                                    style={styles.textarea}
                                    rows={1}  // starts small, auto‑grows or scrolls
                                />
                                <button onClick={handleSend} style={styles.sendBtn}>
                                    <FiSend size={18} color="#fff" />
                                </button>
                            </div>

                            {attachment && (
                                <div style={styles.attachmentPreview}>
                                    📎 {attachment.name}
                                    <button
                                        onClick={() => setAttachment(null)}
                                        style={{
                                            marginLeft: 10,
                                            background: 'none',
                                            border: 'none',
                                            color: '#e74c3c',
                                            cursor: 'pointer',
                                            fontWeight: 'bold',
                                            fontSize: 14,
                                        }}
                                    >
                                        ✕
                                    </button>
                                </div>
                            )}

                            {showDropdown && (
                                <div style={styles.dropdown}>
                                    {mentionDropdown.map((u) => (
                                        <div
                                            key={u.userId}
                                            onClick={() => handleMentionSelect(u.name)}
                                            style={styles.dropdownItem}
                                        >
                                            @{u.name}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

// ===========================
// 🎨 MODERN STYLES (UPDATED with toast)
// ===========================
const styles = {
    wrapper: {
        position: "fixed",
        right: "420px",
        bottom: 20,
        width: 400,
        height: 700,
        backgroundColor: "#f5f7fa",
        borderRadius: "20px",
        boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        display: "flex",
        flexDirection: "column",
        zIndex: 9999,
        transform: "translateX(100%)",
        transition: "transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        overflow: "hidden",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    header: {
        background: "linear-gradient(135deg, #1a1a2e, #16213e)",
        padding: "16px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        color: "white"
    },
    headerTitle: {
        fontWeight: 600,
        fontSize: 16,
        letterSpacing: 0.3,
        color: "#fff",
    },
    closeBtn: {
        background: "transparent",
        border: "none",
        fontSize: 24,
        color: "#fff",
        cursor: "pointer",
        opacity: 0.9,
        transition: "opacity 0.2s",
        padding: "0 4px",
        lineHeight: 1,
    },
    body: {
        flex: 1,
        padding: "12px 16px",
        overflowY: "auto",
        backgroundColor: "#e5e8ed",
        backgroundImage: "radial-gradient(circle at 20% 50%, #eef2f6 0%, #e5e8ed 100%)",
    },
    userItem: {
        display: "flex",
        alignItems: "center",
        padding: "12px 16px",
        backgroundColor: "#fff",
        marginBottom: 2,
        cursor: "pointer",
        transition: "background 0.15s",
        borderRadius: "12px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
    },
    avatar: {
        width: 44,
        height: 44,
        borderRadius: "50%",
        marginRight: 14,
        objectFit: "cover",
    },
    avatarPlaceholder: {
        width: 44,
        height: 44,
        borderRadius: "50%",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: 600,
        marginRight: 14,
        flexShrink: 0,
    },
    userInfo: {
        flex: 1,
        minWidth: 0,
    },
    userName: {
        fontWeight: 600,
        fontSize: 15,
        color: "#1a1a2e",
        marginBottom: 2,
    },
    lastMessage: {
        fontSize: 13,
        color: "#8e8ea0",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    chatHeader: {
        display: "flex",
        alignItems: "center",
        padding: "10px 16px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #e6eaef",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    },
    backBtn: {
        border: "none",
        background: "transparent",
        cursor: "pointer",
        padding: "6px 8px",
        marginRight: 8,
        borderRadius: "50%",
        transition: "background 0.2s",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    chatAvatarWrapper: {
        marginRight: 12,
    },
    chatUserInfo: {
        flex: 1,
    },
    chatUserName: {
        fontWeight: 600,
        fontSize: 16,
        color: "#1a1a2e",
    },
    chatUserStatus: {
        fontSize: 13,
        color: "#8e8ea0",
        display: "flex",
        alignItems: "center",
    },
    messageRow: {
        display: "flex",
        marginBottom: 8,
    },
    messageBubble: {
        maxWidth: "80%",
        padding: "10px 14px",
        borderRadius: "18px",
        lineHeight: 1.5,
        fontSize: "14px",
        wordBreak: "break-word",
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        transition: "all 0.15s",
        whiteSpace: "pre-wrap",   // preserves line breaks
    },
    sender: {
        fontWeight: 600,
        fontSize: 12,
        color: "#555",
        marginBottom: 3,
    },
    timestamp: {
        fontSize: "10px",
        color: "#999",
        textAlign: "right",
        marginTop: 6,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 4,
    },
    typingContainer: {
        display: "flex",
        alignItems: "center",
        padding: "8px 12px",
        marginBottom: 8,
        backgroundColor: "#fff",
        borderRadius: "20px",
        width: "fit-content",
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    },
    typingDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: "#999",
        marginRight: 4,
        animation: "typingPulse 1.4s infinite both",
    },
    inputArea: {
        borderTop: "1px solid #e6eaef",
        padding: "12px 16px",
        backgroundColor: "#ffffff",
        position: "relative",
    },
    inputWrapper: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#f0f2f5",
        borderRadius: "30px",
        padding: "2px 4px 2px 8px",
        border: "1px solid transparent",
        transition: "border 0.2s",
    },
    input: {
        flex: 1,
        border: "none",
        outline: "none",
        background: "transparent",
        padding: "10px 6px",
        fontSize: "14px",
        color: '#1a1a2e',
    },
    sendBtn: {
        background: "#4F46E5",
        color: "#fff",
        border: "none",
        borderRadius: "50%",
        padding: "10px",
        marginLeft: "4px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.2s, transform 0.1s",
        flexShrink: 0,
    },
    attachBtn: {
        background: "transparent",
        border: "none",
        padding: "8px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        transition: "background 0.2s",
        flexShrink: 0,
    },
    dropdown: {
        position: "absolute",
        bottom: "70px",
        left: "16px",
        right: "16px",
        backgroundColor: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        maxHeight: "150px",
        overflowY: "auto",
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        zIndex: 2000,
    },
    dropdownItem: {
        padding: "10px 16px",
        cursor: "pointer",
        borderBottom: "1px solid #f0f0f0",
    },
    attachmentPreview: {
        marginTop: "8px",
        fontSize: "13px",
        color: "#333",
        background: "#f0f2f5",
        padding: "6px 14px",
        borderRadius: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "100%",
    },
    // --- Toast styles ---
    toast: {
        position: 'fixed',
        bottom: 30,
        right: 30,
        backgroundColor: '#1a1a2e',
        color: '#fff',
        padding: '14px 20px',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
        maxWidth: 320,
        zIndex: 10000,
        animation: 'slideUp 0.3s ease-out',
        borderLeft: '4px solid #4F46E5',
    },
    toastSender: {
        fontWeight: 600,
        fontSize: 14,
        marginBottom: 4,
    },
    toastMessage: {
        fontSize: 13,
        opacity: 0.9,
        wordBreak: 'break-word',
    },
    textarea: {
        flex: 1,
        border: "none",
        outline: "none",
        background: "transparent",
        padding: "10px 6px",
        fontSize: "14px",
        color: '#1a1a2e',
        resize: "none",          // prevent manual resizing
        fontFamily: "inherit",
        maxHeight: "120px",      // optional: limit height
        overflowY: "auto",
        lineHeight: 1.5,
        scrollbarWidth: 'none', /* For Firefox */

    },
};

export default RFQChatBox;




// RFQChatHistory.js
// import React, { useState, useEffect, useMemo } from 'react';
// import { jwtDecode } from 'jwt-decode';
// import { FiDownload } from 'react-icons/fi';

export const RFQChatHistory = React.memo(({ rfxId, suppliers, hideDropdown = false, buyer }) => {
    console.log("RFQ Chat History is working :", rfxId, '-----------', suppliers)
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);

    const lastFetchedGroupId = useRef(null);

    const token = localStorage.getItem('token');
    const storedUser = jwtDecode(token);
    const currentUser = useMemo(() => ({
        userId: storedUser?.userId,
        name: storedUser?.userName,
    }), [storedUser]);

    const showDropdown = !hideDropdown && suppliers.length > 1;

    const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9001';

    // Auto‑select the first supplier
    useEffect(() => {
        if (suppliers?.length > 0 && !selectedSupplier) {
            setSelectedSupplier(suppliers[0]);
        }
    }, [suppliers, selectedSupplier]);

    // Fetch messages when supplier changes
    useEffect(() => {
        if (!selectedSupplier || !rfxId || !currentUser.userId) return;

        let ids = [currentUser.userId, selectedSupplier.AssociateNumber].sort();

        if (!buyer) {
            const buyerId = currentUser.userId;
            const supplierId = selectedSupplier.AssociateNumber;
            console.log("buyerID: ", buyerId, "--------", "SupplierID: ", supplierId)
            
            ids = [buyerId, supplierId].sort();
        }
        else if (buyer) {
            const supplierId = currentUser.userId;
            const buyerId = buyer;
            console.log("buyerID: ", buyerId, "--------", "SupplierID: ", supplierId)
            ids = [buyerId, supplierId].sort();
        }

        const privateGroupId = `${rfxId}_${ids.join('_')}`;
        // const privateGroupId = `69fd9224788b1d206b67321e_1ADMIN1_S0204`;

        console.log("Private Group ID: ", privateGroupId)

        if (lastFetchedGroupId.current === privateGroupId) return; // skip duplicate
        lastFetchedGroupId.current = privateGroupId;

        const fetchMessages = async () => {
            setLoading(true);
            try {
                const response = await fetch(
                    `${REACT_APP_API_BASE_URL}socket/api/getMessagesByGroupId`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({ groupId: privateGroupId }),
                    }
                );
                if (!response.ok) throw new Error('Failed to fetch messages');
                const data = await response.json();
                console.log('Raw API response:', data);
                const msgs = Array.isArray(data) ? data : data?.messages || [];
                console.log('Extracted messages array:', msgs);
                console.log('Messages count:', msgs.length);
                setMessages(msgs);
            } catch (error) {
                console.error('Error fetching messages:', error);
                setMessages([]);
            } finally {
                setLoading(false);
            }
        };

        fetchMessages();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSupplier, rfxId, currentUser.userId, token, REACT_APP_API_BASE_URL]);

    // Helper functions (same as in RFQChatBox)
    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        let h = date.getHours();
        const m = date.getMinutes().toString().padStart(2, '0');
        const ampm = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;
        return `${h}:${m} ${ampm}`;
    };

    const formatMessage = (text) => {
        let html = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        html = html.replace(/\n/g, '<br />');
        html = html.replace(/@(\w+)/g, '<span style="color:#0b93f6;font-weight:bold;">@$1</span>');
        return html;
    };

    const dataUrlToBlob = (dataUrl) => {
        const [header, data] = dataUrl.split(',');
        const mime = header.match(/:(.*?);/)[1];
        const binary = atob(data);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            array[i] = binary.charCodeAt(i);
        }
        return new Blob([array], { type: mime });
    };

    const handleViewAttachment = (dataUrl) => {
        const blob = dataUrlToBlob(dataUrl);
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
    };

    useEffect(() => {
        console.log('State messages updated:', messages);
    }, [messages]);

    useEffect(() => {
        console.log('🔄 Loading state changed:', loading);
    }, [loading]);

    if (!suppliers || suppliers.length === 0) {
        return <div className="text-center p-4 text-muted">No Chat associated with this RFQ.</div>;
    }

    return (
        <div style={{ padding: '16px', background: '#fff', borderRadius: '8px' }}>
            {/* Supplier dropdown */}
            {showDropdown && (
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ fontWeight: 500, marginRight: '12px' }}>Select Supplier:</label>
                    <select
                        value={selectedSupplier?.AssociateNumber || ''}
                        onChange={(e) => {
                            const supplier = suppliers.find(s => s.AssociateNumber === e.target.value);
                            setSelectedSupplier(supplier);
                        }}
                        style={{
                            padding: '8px 12px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            minWidth: '200px',
                            background: '#fff',
                        }}
                    >
                        {suppliers.map((s) => (
                            <option key={s.AssociateNumber} value={s.AssociateNumber}>
                                {s.organisationName} ({s.AssociateNumber})
                            </option>
                        ))}
                    </select>
                </div>

            )}

            {/* Messages container */}
            <div
                style={{
                    maxHeight: '500px',
                    overflowY: 'auto',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '12px',
                    backgroundColor: '#f9f9f9',
                }}
            >
                {loading ? (
                    <div className="text-center p-4">Loading messages…</div>
                ) : messages.length === 0 ? (
                    <div className="text-center p-4 text-muted">No messages yet.</div>
                ) : (

                    messages.map((msg, idx) => {
                        const isSender = msg.senderId === currentUser.userId;
                        return (
                            <div
                                key={idx}
                                style={{
                                    display: 'flex',
                                    justifyContent: isSender ? 'flex-end' : 'flex-start',
                                    marginBottom: '8px',
                                }}
                            >
                                <div
                                    style={{
                                        maxWidth: '80%',
                                        padding: '10px 14px',
                                        borderRadius: '18px',
                                        backgroundColor: isSender ? '#d9fdd3' : '#f0f0f0',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                                        wordBreak: 'break-word',
                                    }}
                                >
                                    <div style={{ fontWeight: 600, fontSize: '12px', color: '#555', marginBottom: '3px' }}>
                                        {isSender ? 'You' : msg.senderName || 'Supplier'}
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: formatMessage(msg.message) }} />

                                    {/* Attachment rendering (if any) */}
                                    {msg.attachment && (
                                        <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                            {msg.attachment.type?.startsWith('image/') ? (
                                                <div>
                                                    <img
                                                        src={msg.attachment.data}
                                                        alt={msg.attachment.name}
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: 150,
                                                            borderRadius: 8,
                                                            border: '1px solid #ddd',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => handleViewAttachment(msg.attachment.data)}
                                                    />
                                                    <div style={{ marginTop: 4, display: 'flex', gap: 8, alignItems: 'center' }}>
                                                        <span style={{ fontSize: 12, color: '#555' }}>{msg.attachment.name}</span>
                                                        <a
                                                            href={msg.attachment.data}
                                                            download={msg.attachment.name}
                                                            style={{ color: '#0077cc', fontSize: 14 }}
                                                            title="Download"
                                                        >
                                                            <FiDownload size={16} />
                                                        </a>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <span
                                                        onClick={() => handleViewAttachment(msg.attachment.data)}
                                                        style={{
                                                            color: '#0077cc',
                                                            textDecoration: 'underline',
                                                            fontWeight: 500,
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        📎 {msg.attachment.name}
                                                    </span>
                                                    <a
                                                        href={msg.attachment.data}
                                                        download={msg.attachment.name}
                                                        style={{ color: '#0077cc', fontSize: 14 }}
                                                        title="Download"
                                                    >
                                                        <FiDownload size={16} />
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div style={{ fontSize: '10px', color: '#999', textAlign: 'right', marginTop: 6 }}>
                                        {formatTime(msg.timestamp)}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
});

